import { render, staticRenderFns } from "./EmptyPage.vue?vue&type=template&id=765334c4&scoped=true&"
import script from "./EmptyPage.vue?vue&type=script&lang=js&"
export * from "./EmptyPage.vue?vue&type=script&lang=js&"
import style0 from "./EmptyPage.vue?vue&type=style&index=0&id=765334c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765334c4",
  null
  
)

export default component.exports